import { Box } from "@mui/material";
import React, { useRef } from "react";
import DownloadAsPDFBtn from "./btns/DownloadAsPDFBtn";

export default function DownloadablePage({ children, fileName }) {
  const pageRef = useRef();

  return (
    <div className="">
      <Box ref={pageRef}>{children}</Box>

      <DownloadAsPDFBtn fileName={fileName} contentRef={pageRef} />
    </div>
  );
}
